<template>
    <svg viewBox="0 0 24 24" fill="none" :width="size" :height="size">
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        <g id="SVGRepo_iconCarrier"> 
            <path d="M8 18C8 15.7909 9.79086 14 12 14C14.2091 14 16 15.7909 16 18" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            </path> 
            <line x1="21" y1="21" x2="3" y2="21" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></line> 
                <line x1="12" y1="11" x2="12" y2="9" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></line> 
                <path d="M12 11L12 3" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12 11L15 8.5" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12 11L9 8.5" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <line x1="5" y1="18" x2="3" y2="18" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></line> <line x1="21" y1="18" x2="19" y2="18" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></line> <line x1="19.071" y1="11.3432" x2="17.6568" y2="12.7574" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></line> <line x1="5.41421" y1="12" x2="6.82843" y2="13.4142" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></line> 
            </g>
    </svg>
</template>

<script>
export default {
    name: 'IconSunSet',
    props: {
        color: {
            type: String,
            default: "#FFFFFF",
        },
        size: {
            type: String,
            default: "1rem",
        },
    }
}
</script>